"use strict";

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _defineProperty = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _regeneratorRuntime = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var commons_1 = require("../commons"); //tslint:disable:max-classes-per-file


var PartitioningTreeFactory =
/*#__PURE__*/
function () {
  function PartitioningTreeFactory(levels) {
    _classCallCheck(this, PartitioningTreeFactory);

    this.levels = levels;
    /**/
  }

  _createClass(PartitioningTreeFactory, [{
    key: "createTreeItem",
    value: function createTreeItem(level) {
      if (level >= this.levels.size) {
        return new TreeLeaf(this);
      } else {
        return new TreeNode(this.levels.get(level), level, this);
      }
    }
  }, {
    key: "processNormal",
    value: function processNormal(processor, data) {
      commons_1.UNIMPLEMENTED('PartitioningTree.processNormal');
    }
  }, {
    key: "processAsync",
    value: function () {
      var _processAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(processor, data) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                commons_1.UNIMPLEMENTED('PartitioningTree.processAsync');

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function processAsync(_x, _x2) {
        return _processAsync.apply(this, arguments);
      };
    }()
  }]);

  return PartitioningTreeFactory;
}();

exports.PartitioningTreeFactory = PartitioningTreeFactory;

var PartitioningTree =
/*#__PURE__*/
function () {
  function PartitioningTree() {
    _classCallCheck(this, PartitioningTree);
  }

  _createClass(PartitioningTree, [{
    key: "treeNodes",
    value: function treeNodes() {
      var _this = this;

      return _defineProperty({}, Symbol.iterator, function () {
        return new TreeItemIterator(_this);
      });
    }
  }, {
    key: "processors",
    value: function processors() {
      return immutable_1.Seq(this.treeNodes()).filter(function (n) {
        return n.processor !== null;
      }).map(function (n) {
        return n.processor;
      });
    }
  }]);

  return PartitioningTree;
}();

exports.PartitioningTree = PartitioningTree;

var TreeItemIterator =
/*#__PURE__*/
function () {
  function TreeItemIterator(root) {
    _classCallCheck(this, TreeItemIterator);

    this.stack = [];
    this.stack.push(immutable_1.List.of(root)[Symbol.iterator]());
  }

  _createClass(TreeItemIterator, [{
    key: "next",
    value: function next(value) {
      var iter = this.stack.pop();

      if (iter === undefined) {
        return {
          done: true
        };
      }

      var next = iter.next();

      if (!next.done) {
        this.stack.push(iter, next.value.nodes());
        return {
          done: false,
          value: next.value
        };
      }

      return this.next();
    }
  }]);

  return TreeItemIterator;
}();

var TreeNode =
/*#__PURE__*/
function (_PartitioningTree) {
  _inherits(TreeNode, _PartitioningTree);

  function TreeNode(key, level, factory) {
    var _this2;

    _classCallCheck(this, TreeNode);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(TreeNode).call(this));
    _this2.key = key;
    _this2.level = level;
    _this2.factory = factory;
    _this2.subs = new Map();
    return _this2;
  }

  _createClass(TreeNode, [{
    key: "nodes",
    value: function nodes() {
      return this.subs.values();
    }
  }, {
    key: "processNormal",
    value: function processNormal(qualifiers, value) {
      var sub = this.getSubTree(qualifiers);
      return sub.processNormal(qualifiers, value);
    }
  }, {
    key: "processAsync",
    value: function processAsync(qualifiers, value) {
      var sub = this.getSubTree(qualifiers);
      return sub.processAsync(qualifiers, value);
    }
  }, {
    key: "getSubTree",
    value: function getSubTree(qualifiers) {
      var qualifier = qualifiers[this.key];
      var sub = this.subs.get(qualifier);

      if (!sub) {
        sub = this.factory.createTreeItem(this.level + 1);
        this.subs.set(qualifier, sub);
      }

      return sub;
    }
  }, {
    key: "processor",
    get: function get() {
      return null;
    }
  }]);

  return TreeNode;
}(PartitioningTree);

var TreeLeaf =
/*#__PURE__*/
function (_PartitioningTree2) {
  _inherits(TreeLeaf, _PartitioningTree2);

  function TreeLeaf(treeFactory) {
    var _this3;

    _classCallCheck(this, TreeLeaf);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(TreeLeaf).call(this));
    _this3.treeFactory = treeFactory;
    return _this3;
  }

  _createClass(TreeLeaf, [{
    key: "nodes",
    value: function nodes() {
      return immutable_1.List()[Symbol.iterator]();
    }
  }, {
    key: "processNormal",
    value: function processNormal(qualifiers, value) {
      var proc = this.assertProcessor(qualifiers);
      this.treeFactory.processNormal(proc, value);
    }
  }, {
    key: "processAsync",
    value: function processAsync(qualifiers, value) {
      var proc = this.assertProcessor(qualifiers);
      return this.treeFactory.processAsync(proc, value);
    }
  }, {
    key: "assertProcessor",
    value: function assertProcessor(qualifiers) {
      if (!this.processor) {
        this.processor = this.treeFactory.createProcessor(qualifiers);
      }

      return this.processor;
    }
  }]);

  return TreeLeaf;
}(PartitioningTree);